import React from 'react';
import { TableProvider } from 'providers';
import Tables from './Page';

export default function Page() {
  return (
    <TableProvider>
      <Tables />
    </TableProvider>
  );
}
